import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=fb9d06b8"
import script from "./Congratulations.vue?vue&type=script&lang=ts"
export * from "./Congratulations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports